/**
 * Scale ETF live ticks (SPY, QQQ, …) to index chart levels (SPX, NDX, …).
 * Used when Polygon index WS / I:SPX REST are unavailable on the API plan.
 */

export function computeIndexEtfScale(
    indexPrice: number,
    etfPrice: number,
    fallback = 1,
): number {
    if (indexPrice > 0 && etfPrice > 0) {
        const ratio = indexPrice / etfPrice;
        if (ratio > 1.02 || ratio < 0.98) return ratio;
    }
    return fallback > 0 ? fallback : 1;
}

export function scaleEtfToIndex(etfPrice: number, scale: number): number {
    if (!etfPrice || etfPrice <= 0 || !scale || scale <= 0) return 0;
    return etfPrice * scale;
}
